import React from 'react';
import ButtonBase from './ButtonBase';
import classNames from 'classnames';
import './Button.less';

function Button(props) {
    let buttonClasses = classNames('btn-default', props.className);

    return (
        <ButtonBase {...props} className={buttonClasses}/>
    );
}

Button.propTypes = {
    ...ButtonBase.propTypes
};

Button.defaultProps = {
    ...ButtonBase.defaultProps
};

export default Button;
